import { Event } from '../types/event';

export function generateIcsContent(events: Event[]): string {
  const icsEvents = events.map(event => {
    const start = event.start.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    const end = event.end.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    
    return `BEGIN:VEVENT
UID:${event.id}@riverhack.com
DTSTAMP:${start}
DTSTART:${start}
DTEND:${end}
SUMMARY:${event.name}
DESCRIPTION:${event.description}
LOCATION:${event.location}
END:VEVENT`;
  }).join('\n');

  return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//RiverHack//Schedule//EN
CALSCALE:GREGORIAN
${icsEvents}
END:VCALENDAR`;
} 